import { View, Text } from 'src/components/common';
import { connect } from 'react-redux';
import InformationText from 'src/components/DepositionDetailItem/InformationText';
import './styles.scss';
import { IAppState } from 'src/store';
import InvolvedParties from 'src/components/DepositionDetailItem/InvolvedParties';
import RequestedBy from 'src/components/DepositionDetailItem/RequestedBy';
import DepositionBadge from 'src/components/DepositionBadge';
import { Deposition, People } from 'src/dataFactory/depositionFactory';

const DepositionDetailItem: React.FC<Props> = ({ data, className, circuits }) => {
  return (
    <View className={className ? className : ''}>
      <View className={'detail-item'} onClick={() => {}}>
        <DepositionBadge variant={data.status} className={'detail-item__badge'} />
        {!!data.caption && <View className={'detail-item-description mt-5'}>{data.caption}</View>}
        <InformationText title={'Case Name'} value={data.caseName} />
        <InformationText title={'Deposition ID'} value={data.caseId} />
        <InformationText title={'Open Date'} value={data.openDate} />
        <InformationText title={'Actual Deposition Date'} value={data.actualDepositionDate} />
        <InformationText title={'Actual Deposition Time'} value={data.actualDepositionTime} />

        {data.requester && data.requester.role !== 'ADMIN' && (
          <View className={`detail-item__requested-by have-requested`}>
            <Text className={'detail-item-text mt-16'}>{`Requested by`}</Text>
            <RequestedBy user={data.requester} />
          </View>
        )}
        <View className={'detail-item-involved-parties`'}>
          <Text className={'detail-item-text mt-16'}>{`Involved Parties (${data.involvedParties.length})`}</Text>
          {data.involvedParties.map((user: People, index: number) => (
            <InvolvedParties key={`involved-party-${index}`} user={user} />
          ))}
        </View>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    data: Deposition;
    className?: string;
  };
const mapStateToProps = (state: IAppState) => ({
  circuits: state.content.circuits,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionDetailItem);
